var _path;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgLikeInContest(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 20,
    height: 20,
    viewBox: "0 0 20 20",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M9.99996 17.7917L8.79163 16.6917C4.49996 12.8 1.66663 10.225 1.66663 7.08333C1.66663 4.50833 3.68329 2.5 6.24996 2.5C7.69996 2.5 9.09163 3.175 9.99996 4.23333C10.9083 3.175 12.3 2.5 13.75 2.5C16.3166 2.5 18.3333 4.50833 18.3333 7.08333C18.3333 10.225 15.5 12.8 11.2083 16.6917L9.99996 17.7917Z",
    fill: "#F11057"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgLikeInContest);
export default __webpack_public_path__ + "static/media/likeInContest.be615bec7c3c58d2007176096db47e5b.svg";
export { ForwardRef as ReactComponent };